// Polyfill for process global
// Minimal implementation for browser compatibility

interface ProcessPolyfill {
  env: {
    NODE_ENV: string;
  };
  version: string;
  versions: {
    node: string;
  };
  platform: string;
  browser: boolean;
  cwd: () => string;
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  nextTick: (fn: (...args: any[]) => void, ...args: any[]) => void;
}

const processPolyfill: ProcessPolyfill = {
  env: {
    NODE_ENV: import.meta.env.MODE === 'production' ? 'production' : 'development',
  },
  version: 'v18.0.0',
  versions: {
    node: '18.0.0',
  },
  platform: 'browser',
  browser: true,
  cwd: () => '/',
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  nextTick: (fn: (...args: any[]) => void, ...args: any[]) => {
    Promise.resolve().then(() => fn(...args));
  },
};

// Extend global interfaces to include process
declare global {
  interface Window {
    process: ProcessPolyfill;
  }
}

// Make process available globally
// Use type assertion to avoid conflicts with Node.js Process type
(window as Window).process = processPolyfill;
// Use any to bypass the type conflict with Node.js Process
// eslint-disable-next-line @typescript-eslint/no-explicit-any
(globalThis as any).process = processPolyfill;

export default processPolyfill;
